import './testimonios.css';
import { bindProgress } from '../scrollfx.js';
import { reproducir, detener } from '../player/player.js';

// Sección — "Testimonios v2" (Claude Design, proyecto dd25dfb7).
// Cambios de la v2 frente a la anterior: la sección vuelve a OSCURO, trae el
// separador del patrón 2b arriba (regla + 96px de aire), UNA sola viga cian, y
// el muro deja de ser masonry automático: son TRES COLUMNAS explícitas con un
// orden decidido (el reel alto abre la 1, la cita destacada abre la 2, una
// captura abre la 3), dentro de una ventana con scroll propio y máscara.
//
// Los reels/capturas/avatares siguen siendo PLACEHOLDERS hasta tener media real
// (drop en public/ + wire del src).

// LOS TESTIMONIOS.
//
// Los reels y las capturas de LinkedIn son REALES: salieron de la landing de
// WordPress, con su video, su portada, su nombre y su puesto. Las citas son las
// palabras de cada quien, no un texto escrito por nosotros.
//
// LO QUE SIGUE SIENDO MAQUETA, y se marca aquí para que nadie lo confunda:
//   · las capturas de CORREO (`kind: 'mail'`) — no tenemos ninguna
//   · las tarjetas de solo texto (`t: 'quote'`) — sus nombres son inventados
// Se quedan como plantilla a propósito: enseñan la forma de la sección sin
// atribuirle una frase inventada a una persona real. Al llegar el material se
// reemplazan igual que los reels.
//
// El video de cada reel NO se declara aquí: se pide por clave a
// `config/videos.js`, que es el único registro de video del sitio.
const COLS = [
  // Reparto POR ALTURA, no por número de tarjetas (medidas a 1440 px). Al entrar
  // Ricardo la primera columna se fue a 1601 px contra 1345 de la segunda; así
  // quedan en 1386, 1347 y 1394.
  //
  // Dos reglas de composición: cada columna ABRE con un reel —la primera fila
  // son tres videos— y ninguna apila dos reels seguidos.
  [
    { t: 'reel', h: 520, real: true, clave: 'reel-juan-cabezas', poster: '/reel-juan-cabezas.webp',
      q: '“Hoy soy gerente de OPEX en España”', n: 'Juan Cabezas', r: 'Gerente de OPEX' },
    { t: 'shot', h: 330, real: true, img: '/li-elber-m.webp',
      alt: 'Elber M. comparte su certificado de Process Validation en LinkedIn',
      n: 'Elber M.', label: 'Certificado de Process Validation' },
    { t: 'shot', h: 340, real: true, img: '/li-jake-rufino.webp',
      alt: 'Jake Rufino comparte su diploma de SMED en LinkedIn',
      n: 'Jake Rufino', label: 'Diploma de SMED' },
  ],
  [
    { t: 'reel', h: 500, real: true, clave: 'reel-alfonso', poster: '/reel-alfonso.webp',
      q: '“Es excelente para seguir creciendo”', n: 'Alfonso', r: 'Manufactura' },
    { t: 'shot', h: 355, real: true, img: '/li-jose-emmanuel-reyes.webp',
      alt: 'José Emmanuel Reyes comparte su diploma de Estadística Avanzada en LinkedIn',
      n: 'José Emmanuel Reyes', label: 'Diploma de Estadística Avanzada' },
    { t: 'reel', h: 480, real: true, clave: 'reel-christian', poster: '/reel-christian.webp',
      q: '“Zenkai realmente es la diferencia”', n: 'Christian', r: 'OPEX' },
  ],
  [
    { t: 'reel', h: 460, real: true, clave: 'reel-noe', poster: '/reel-noe.webp',
      q: '“El impacto ha sido drástico”', n: 'Noe', r: 'Supply Chain' },
    { t: 'shot', h: 365, real: true, img: '/li-julimari-arias.webp',
      alt: 'Julimari Arias comparte su diploma de Lean Thinking en LinkedIn',
      n: 'Julimari Arias', label: 'Diploma de Lean Thinking' },
    { t: 'shot', h: 300, real: true, img: '/li-gustavo-marfia.webp',
      alt: 'Gustavo Marfia recomienda Zenkai en LinkedIn',
      n: 'Gustavo Marfia', label: 'Recomienda Zenkai en LinkedIn' },
    { t: 'quote', real: true, big: true,
      q: 'De ingeniero Jr a gerente. Hoy visita plantas alrededor del mundo.', n: 'Ricardo', r: 'Gerente' },
  ],
];

const PLAY = `<svg width="17" height="19" viewBox="0 0 17 19"><path d="M0 0l17 9.5L0 19z"/></svg>`;
const MARK = `<svg class="zk-tm__mark" width="34" height="34" viewBox="0 0 40 40"><path d="M6 22c0-8 5-13 12-14l1 3c-4 1-7 4-7 8h6v11H6V22zm18 0c0-8 5-13 12-14l1 3c-4 1-7 4-7 8h6v11H24V22z"/></svg>`;
const ICON = {
  msg: `<svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M21 11.5a8.38 8.38 0 0 1-8.5 8.5 9 9 0 0 1-3.8-.8L3 21l1.9-5.7A8.38 8.38 0 0 1 4 11.5 8.5 8.5 0 0 1 12.5 3 8.38 8.38 0 0 1 21 11.5z"/></svg>`,
  mail: `<svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 7l9 6 9-6"/></svg>`,
};

// Ensō de marca — el rojo entra SOLO aquí, nunca en un control. Mismo trazo que
// en las demás secciones; el v2 del diseño lo omitía y rompía la consistencia.
const ENSO = `<svg viewBox="0 0 100 100" width="16" height="16" aria-hidden="true"><circle cx="50" cy="52" r="38" fill="none" stroke="currentColor" stroke-width="12" stroke-linecap="round" stroke-dasharray="205 300" transform="rotate(122 50 50)"/></svg>`;

const initial = (name) => name.trim().charAt(0).toUpperCase();

// SOLO LO REAL SE DIBUJA.
//
// Quedan en `COLS` tres tarjetas de maqueta —la cita de "Daniela G.", que es un
// nombre y una frase inventados, y las dos capturas de marcador (mensaje y
// correo)—. Se OCULTAN, no se borran: enseñan la forma de la sección y el día
// que llegue una captura real se le pone `real: true` y vuelve sola.
//
// Estaban visibles a propósito mientras la sección era casi toda maqueta. Con
// nueve testimonios de verdad ya no hacen falta, y un testimonio inventado al
// lado de nueve reales le resta credibilidad a los nueve.
const esReal = (c) => c.real === true;

function cardHTML(c) {
  if (c.t === 'reel') {
    // El video NO se carga aqui: solo la portada. Se abre en el visor al hacer
    // clic, igual que el resto de los reproductores del sitio.
    return `<button type="button" class="zk-tm__card zk-tm__reel" data-reveal style="height:${c.h}px"
      data-clave="${c.clave}" aria-label="Ver el testimonio de ${c.n}">
      <img class="zk-tm__reel-img" src="${c.poster}" alt="" loading="lazy" decoding="async" />
      <div class="zk-tm__reel-scrim" aria-hidden="true"></div>
      <span class="zk-tm__play" aria-hidden="true">${PLAY}</span>
      <div class="zk-tm__reel-body">
        <p>${c.q}</p>
        <div class="zk-tm__reel-foot">
          <div><div class="n">${c.n}</div><div class="r">${c.r}</div></div>
          <div class="zk-tm__stars" aria-label="5 de 5">★★★★★</div>
        </div>
      </div>
    </button>`;
  }
  if (c.t === 'quote') {
    return `<div class="zk-tm__card zk-tm__quote${c.big ? ' zk-tm__quote--big' : ''}" data-reveal>
      ${c.mark ? MARK : ''}
      <p>${c.q}</p>
      <div class="zk-tm__cite">
        <div class="zk-tm__avatar" aria-hidden="true">${initial(c.n)}</div>
        <div><div class="n">${c.n}</div><div class="r">${c.r}</div></div>
      </div>
    </div>`;
  }
  // Captura REAL: la imagen manda y debajo va quien es y de que. Las de
  // maqueta se quedan con su icono y su etiqueta.
  if (c.real) {
    return `<figure class="zk-tm__card zk-tm__shot zk-tm__shot--real" data-reveal>
      <img src="${c.img}" alt="${c.alt}" loading="lazy" decoding="async" />
      <figcaption><span class="n">${c.n}</span><span class="l">${c.label}</span></figcaption>
    </figure>`;
  }
  return `<div class="zk-tm__card zk-tm__shot" data-reveal>
    <div class="zk-tm__shot-inner" style="height:${c.h}px">
      ${ICON[c.kind] || ICON.msg}
      <span>${c.label}</span>
    </div>
  </div>`;
}

function markup() {
  return `
  <div class="zk-tm__beam" aria-hidden="true"></div>

  <div class="zk-tm__wrap">
    <header class="zk-tm__head">
      <div>
        <div class="zk-tm__eyebrow" data-reveal>${ENSO}<span>La prueba</span></div>
        <h2 class="zk-tm__title" data-reveal>Cambió la carrera de miles de ingenieros. Ellos lo cuentan mejor.</h2>
      </div>
      <div class="zk-tm__metrics" data-reveal>
        <div class="zk-tm__metric"><b>+10,000</b><span>ingenieros formados</span></div>
        <div class="zk-tm__mdiv"></div>
        <div class="zk-tm__metric"><b>4.9<span class="star">★</span></b><span>promedio de reseñas</span></div>
      </div>
    </header>

    <div class="zk-tm__scroll" data-lenis-prevent>
      <div class="zk-tm__grid">
        ${COLS.map((col) => `<div class="zk-tm__col">${col.filter(esReal).map(cardHTML).join('')}</div>`).join('')}
      </div>
    </div>
    <p class="zk-tm__more">Desliza para ver más historias</p>
  </div>`;
}

/**
 * Monta la sección de Testimonios dentro de `mount`.
 * @returns {HTMLElement} la <section> montada.
 */
export function mountTestimonios(mount) {
  const section = document.createElement('section');
  section.className = 'zk-tm';            // v2: vuelve a OSCURO
  section.id = 'testimonios';
  section.setAttribute('aria-label', 'Testimonios de ingenieros de Zenkai');
  section.innerHTML = markup() + `
    <div class="zk-tm__lb" data-open="false" role="dialog" aria-modal="true" aria-label="Testimonio en video">
      <button type="button" class="zk-tm__lb-close" aria-label="Cerrar el video">✕</button>
      <div class="zk-tm__lb-inner"></div>
    </div>`;
  (mount || document.body).appendChild(section);

  // EL VISOR DE LOS REELS. Son verticales (9:16), así que el marco también lo
  // es. Se abre con la portada, se cierra con la ✕, con el fondo o con Esc, y
  // al cerrar se DESTRUYE el reproductor: si solo se ocultara, el audio seguiría
  // sonando detrás de una página que ya no lo muestra.
  const lb = section.querySelector('.zk-tm__lb');
  const lbInner = section.querySelector('.zk-tm__lb-inner');
  let ultimo = null;                     // a dónde devolver el foco al cerrar
  const cerrar = () => {
    if (lb.getAttribute('data-open') !== 'true') return;
    lb.setAttribute('data-open', 'false');
    detener(lbInner);
    ultimo?.focus();
  };
  section.querySelectorAll('.zk-tm__reel').forEach((b) => {
    b.addEventListener('click', () => {
      if (!reproducir(lbInner, b.dataset.clave)) return;   // sin pieza, no se abre nada
      ultimo = b;
      lb.setAttribute('data-open', 'true');
      lb.querySelector('.zk-tm__lb-close').focus();
    });
  });
  lb.querySelector('.zk-tm__lb-close').addEventListener('click', cerrar);
  lb.addEventListener('click', (e) => { if (e.target === lb) cerrar(); });
  window.addEventListener('keydown', (e) => { if (e.key === 'Escape') cerrar(); });

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealEls = [...section.querySelectorAll('[data-reveal]')];

  if (reduced) {
    revealEls.forEach((el) => el.classList.add('is-shown'));
    section.classList.add('is-in');
    return section;
  }

  section.classList.add('is-fx');
  // Cascada escalonada al entrar (Framer/GSAP): retardo por orden, tope suave.
  // 34 ms por tarjeta y no 55: son 13 elementos, y a 55 el escalonado duraba
  // 660 ms —medido en la página, no estimado—. El tope de la regla son 500, y
  // por encima el último en entrar llega cuando el visitante ya dejó de mirar.
  // Una rejilla de tarjetas pide cascada corta (20–40 ms), no la de un héroe.
  revealEls.forEach((el, i) => { el.style.transitionDelay = `${Math.min(i * 34, 420)}ms`; });
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { section.classList.add('is-in'); io.disconnect(); } });
    }, { threshold: 0.12 });
    io.observe(section);
  } else {
    section.classList.add('is-in');
  }

  // Parallax sutil de la viga (optimizado: scrollY, sin reflow por frame).
  bindProgress(section, (p) => section.style.setProperty('--through', p.toFixed(4)));

  return section;
}
